import { memo, ReactNode } from 'react';

import {
  InnerBox,
  ParentBox,
  StaticInnerBox,
} from '../../../../components/rectangle/style';
import { CustomThemeInterface } from '../../../../interface/custom-theme';
import { RootState } from '../../../../store';
import { useAppSelector } from '../../../../store/hooks';

interface MultiStoreCardFrameProps {
  // scheda da scegliere (bordo che si accende al passaggio, puntatore); senza, scheda statica
  isSelectable?: boolean;
  // scheda scelta: bordo e sfondo del Rectangle attivo
  isActive?: boolean;
  children: ReactNode;
}

const selectRectangle = (
  state: RootState
): CustomThemeInterface['rectangle'] => state.customTheme.customTheme.rectangle;

// Riquadro delle schede dei centri con la stessa resa di Rectangle e StaticRectangle
// (components/rectangle, stessi stili e misure del tema dell'insegna) ma senza la loro key
// nanoid, che rimonta i figli a ogni render. Le schede si ridisegnano a ogni risposta di un
// centro o refetch: rimontate, perderebbero il focus dei chip e i clic a metà.
// Clic e tastiera restano al contenitore con il ruolo ARIA che avvolge il riquadro.
export const MultiStoreCardFrame = memo(function MultiStoreCardFrame({
  isSelectable = false,
  isActive = false,
  children,
}: MultiStoreCardFrameProps): JSX.Element {
  const rectangle = useAppSelector(selectRectangle);

  if (!isSelectable) {
    return (
      <ParentBox borderRadius={rectangle.borderRadius} staticType>
        <StaticInnerBox borderWidth={rectangle.borderWidth}>
          {children}
        </StaticInnerBox>
      </ParentBox>
    );
  }

  return (
    <ParentBox borderRadius={rectangle.borderRadius}>
      <InnerBox
        selected={isActive}
        borderWidth={rectangle.borderWidth}
        borderWidthEnable={rectangle.borderWidthEnable}
      >
        {children}
      </InnerBox>
    </ParentBox>
  );
});
